import { createFileRoute } from "@tanstack/react-router";
import { ComingSoonPage } from "@/components/layout/page-container.tsx";

export const Route = createFileRoute("/experiments")({
  component: () => <ComingSoonPage title="量子实验" />,
});
